module.exports = __webpack_public_path__ + "static/media/sweetpotato.ae0b5f48.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/finals/portfolios/sweetpotato.png
// module id = 288
// module chunks = 0